import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { executeOnSingleOrMultiple, isBoolean } from "../../../../Utils/Utils";
import { ClickEvent } from "./ClickEvent";
import { DivEvent } from "./DivEvent";
import { HoverEvent } from "./HoverEvent";
import { ResizeEvent } from "./ResizeEvent";
export var Events = /*#__PURE__*/function () {
  function Events() {
    _classCallCheck(this, Events);

    this.onClick = new ClickEvent();
    this.onDiv = new DivEvent();
    this.onHover = new HoverEvent();
    this.resize = new ResizeEvent();
  }

  _createClass(Events, [{
    key: "onclick",
    get: function get() {
      return this.onClick;
    },
    set: function set(value) {
      this.onClick = value;
    }
  }, {
    key: "ondiv",
    get: function get() {
      return this.onDiv;
    },
    set: function set(value) {
      this.onDiv = value;
    }
  }, {
    key: "onhover",
    get: function get() {
      return this.onHover;
    },
    set: function set(value) {
      this.onHover = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _data$onClick, _data$onDiv, _data$onHover;

      if (!data) {
        return;
      }

      this.onClick.load((_data$onClick = data.onClick) !== null && _data$onClick !== void 0 ? _data$onClick : data.onclick);
      var onDiv = (_data$onDiv = data.onDiv) !== null && _data$onDiv !== void 0 ? _data$onDiv : data.ondiv;

      if (onDiv !== undefined) {
        this.onDiv = executeOnSingleOrMultiple(onDiv, function (t) {
          var tmp = new DivEvent();
          tmp.load(t);
          return tmp;
        });
      }

      this.onHover.load((_data$onHover = data.onHover) !== null && _data$onHover !== void 0 ? _data$onHover : data.onhover);

      if (isBoolean(data.resize)) {
        this.resize.enable = data.resize;
      } else {
        this.resize.load(data.resize);
      }
    }
  }]);

  return Events;
}();